import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";

import { Identifiable, CalendarHolidays } from "@planzone/dto";

import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  calendarsHolidays: Identifiable<CalendarHolidays>[];
  retrieveCalendarHolidays(
    request: Boundaries["retrieveCalendarsHolidays"]["request"],
  ): void;
}

function useRetrieveCalendarsHolidays(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveCalendarsHolidaysPending(),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveCalendarsHolidaysSuccess(),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveCalendarsHolidaysFailure(),
    ),
    calendarsHolidays: useSelector(selector.getCalendarsHolidays),
    retrieveCalendarHolidays: core.retrieveCalendarsHolidays,
  };
}

export { useRetrieveCalendarsHolidays };
